export const version = "ethers/5.1.4";
//# sourceMappingURL=_version.js.map